import React from 'react'
import ProjectPage from '../Components/ProjectPage'

function ProjectDetail() {
  return (
    <div>
      <ProjectPage />
    </div>
  );
}

export default ProjectDetail;
